module.exports = __webpack_public_path__ + "media/application/images/ui/thumbs-down-d4725138c396a6a58a50f75bf13dd118.svg";